import { css } from "@emotion/css";
import { EnvironmentIcon, SnowflakeIcon } from "@octopusdeploy/design-system-icons";
import type { EnvironmentType } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { cardStyles } from "~/areas/dashboard/Onboarding/WelcomeDialog/Cards/styles";
import Card from "~/components/Card";
import InfoDialogLayout from "~/components/DialogLayout/InfoDialogLayout";
interface EnvironmentTypeDialogLayoutProps {
    onSelectType: (type: EnvironmentType) => void;
}
export const EnvironmentTypeDialogLayout = (props: EnvironmentTypeDialogLayoutProps) => {
    const cardContainer = css({
        display: "flex", // displays cards side by side
    });
    return (<InfoDialogLayout title="Select Environment Type" closeButtonLabel="Cancel">
            <div className={cardContainer}>
                <Card onClick={() => props.onSelectType("Static")} logo={<EnvironmentIcon size={24}/>} header={<div className={cardStyles.header}>Environment</div>} content="An environment groups together all the deployment targets used to host your software application." className={cardStyles.card} contentClassName={cardStyles.content} leftAlign={true}/>
                <Card onClick={() => props.onSelectType("Parent")} logo={<SnowflakeIcon size={24}/>} header={<div className={cardStyles.header}>Parent Environment</div>} content="A parent environment groups ephemeral environment and can't be deployed to directly." className={cardStyles.card} contentClassName={cardStyles.content} leftAlign={true}/>
            </div>
        </InfoDialogLayout>);
};
export default EnvironmentTypeDialogLayout;
